<template lang="html">
  <div class="elevation-1 patientinfo" style="padding: 5px;">
    <table>
      <thead>
        <tr class="white--text">
          <th class="plabel">Name</th>
          <th class="plabel">Age</th>
          <th class="plabel">Sex</th>
        </tr>
      </thead>
        <tr>
          <td class="pcontent">{{patientInfo.name}}</td>
          <td class="pcontent">{{patientInfo.age}}</td>
          <td class="pcontent">{{patientInfo.sex}}</td>
        </tr>
      <thead>
        <tr class="white--text">
          <th class="plabel">Setting</th>
          <th class="plabel">Encounter</th>
          <th class="plabel">Photo</th>
        </tr>
      </thead>

      <tr>
        <td class="pcontent">{{patientInfo.setting}}</td>
        <td class="pcontent">{{encounterId}}</td>
        <td class="pcontent">
          <v-btn text v-if="patientInfo.media" @click="showProfileImage = true;">
            <v-icon>account_circle</v-icon>
          </v-btn>
          <v-dialog width="30%" v-model="showProfileImage">
            <img :src="profileImage()" />
          </v-dialog>
        </td>
      </tr>
    </table>
    <div class="actions">
      <v-btn small text outlined class="actions__btn" :disabled="!canGoPrev" @click="prevEncounter" color="primary">
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <v-btn small text outlined class="actions__btn" :disabled="!nextible" @click="goNext" color="primary">
        <v-icon v-if="progress">schedule</v-icon>
        <v-icon v-else>chevron_right</v-icon>
      </v-btn>
    </div>
    <!-- The countdown snack bar. -->
    <v-snackbar
      v-model="showCountDown"
      :color="countDownBgColor"
      :multi-line="countDownMultiLine"
      :timeout="countDownTimeOut"
      :top="false"
      :right="true"
      :vertical="true"
    >
      <count-down :seconds="countDownTimer"></count-down>
    </v-snackbar>
    <v-snackbar v-model="progressAlert" color="primary">
      This is the last encounter for this case.
    </v-snackbar>
    <v-dialog v-model="progressDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">See patient progress?</v-card-title>
        <v-card-text>Do you want to see patient progress?.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click.native="progress=false; progressDialog=false; showProgress()">Yes</v-btn>
          <v-btn text color="secondary" @click.native="progressDialog=false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="signUpInfoDlg" persistent max-width="300">
      <v-card>
        <v-card-text style="padding-top: 10%">
          You are registered as a user without access to progress reports or subsequent patient encounters. Please contact us at help@pblmed.com to gain access to these features.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text color="primary" @click.native="signUpInfoDlg=false">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CountDown from '../CountDown'

export default {
  data () {
    return {
      showCountDown: false,
      countDownTimer: 5,
      countDownBgColor: 'primary',
      countDownMultiLine: false,
      showProfileImage: false,
      progress: true,
      progressDialog: false,
      progressAlert: false,
      signUpInfoDlg: false,
      nextible: true,
      encounterIdx: 0,
      encounters: ['Initial', '2nd', '3rd', '4th', '5th', '6th']
    }
  },
  components: {
    CountDown
  },
  watch: {
    caseId: {
      handler: function (cid) {
        this.progress = true
        this.nextible = true
      }
    },
    encounterId: {
      handler: function (eid) {
        this.progress = true
        this.nextible = true
      }
    }
  },
  computed: {
    countDownTimeOut () {
      return this.countDownTimer * 1000 + 2000
    },
    ...mapGetters({
      'patientInfo': 'getPatientInfo',
      'caseId': 'getCaseId',
      'encounterId': 'getEncounterId',
      userType: 'getUserType',
      caseEncounters: 'getCaseEncounterCount',
      encounterData: 'getEncounterData'
    }),
    canGoNext () {
      return this.nextible && (this.caseEncounters > this.encounterIdx + 1)
    },
    canGoPrev () {
      return this.encounterIdx > 0
    }
  },
  methods: {
    updatePatientInfo: function () {
    },
    profileImage () {
      return `/static/files/${this.caseId}/${this.encounterId}/${this.patientInfo.media}`
    },
    nextEncounter () {
      this.nextible = true
      this.progress = false
    },
    prevEncounter () {
      // this.$store.dispatch('setPrevEncounter')
      this.encounterIdx--
      if (this.encounterIdx >= 0) {
        const encId = this.encounters[this.encounterIdx]
        this.$store.dispatch('setEncounterId', encId)
      } else {
        console.log('This is already the first encounter of the case.')
      }
      console.log(`Current encounter is: ${this.encounterId} : ${this.encounterIdx} / ${this.caseEncounters}`)
    },
    showProgress () {
      let progress = this.encounterData.filter(q => {
        return q.query.toLowerCase().includes('patient progress') && q.type === 'ZP'
      })
      this.$store.dispatch('selectQuery', progress[0])
    },
    goNext () {
      if (this.userType === 'trial') {
        this.signUpInfoDlg = true
        // this.nextible = false
        return
      }
      if (this.progress) {
        this.progressDialog = true
        return
      }
      console.log('Encounter index: ', this.encounterIdx)
      if (this.nextible) {
        const idx = this.encounters.findIndex((e) => {
          return this.encounterId === e
        })
        console.log(`Current encounter is: ${this.encounterId} : ${idx + 1} / ${this.caseEncounters}`)
        if (idx + 1 >= this.caseEncounters) {
          console.log('Cannot go next, this is already the last one.')
          this.progressAlert = true
          this.nextible = false
          this.showProgress()
          return
        }
        const nextEnc = this.encounters[idx + 1]
        // this.$store.dispatch('setNextEncounter')
        this.$store.dispatch('setEncounterId', nextEnc)
        this.encounterIdx = idx + 1
        this.nextible = true
        // this.progress = false
      }
    }
  },
  mounted () {
    if (this.patientInfo === undefined || this.patientInfo === null) {
      this.$router.push({
        path: '/cases'
      })
    }
  }
}
</script>

<style lang="css">
.plabel {
  font-size: 1em;
  font-weight: bold;
  text-align: center;
  line-height: 2.5em;
  background-color:#1E88E5;
  width: 200px;
}
.pcontent {
  line-height: 1em;
  font-size: .75em;
  padding: 10px 0;
  text-align: center;
}
.actions {
  width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
}
.actions__btn {
  align-self: center;
  margin: 10px;
  /* color: lightblue; */
  width: 20%;
}
</style>



// WEBPACK FOOTER //
// src/components/Case/components/PatientInfo.vue